import { render } from "./CreateGroup.vue?vue&type=template&id=9ce776dc"
import script from "./CreateGroup.vue?vue&type=script&lang=js"
export * from "./CreateGroup.vue?vue&type=script&lang=js"
script.render = render

export default script